import { render, staticRenderFns } from "./batchAction.vue?vue&type=template&id=3cf7145c&scoped=true"
import script from "./batchAction.vue?vue&type=script&lang=js"
export * from "./batchAction.vue?vue&type=script&lang=js"
import style0 from "./batchAction.vue?vue&type=style&index=0&id=3cf7145c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf7145c",
  null
  
)

export default component.exports